<template>
  <lay-row space="10" style="padding: 10px;color: #303030">
    <lay-col md-offset="4"  lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES1T02']?.cabinet_no}】${context['ES1T02']?.cabinet_name}`, location: context['ES1T02']?.location, type: context['ES1T02']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>1ES配电室（1）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES1T02", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES1T02", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES1T02", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES1Y02", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES1S02", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES1T02']?.now, context?.['ES1Y02']?.now, context?.['ES1S02']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
    <lay-col lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES2T02']?.cabinet_no}】${context['ES2T02']?.cabinet_name}`, location: context['ES2T02']?.location, type: context['ES2T02']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>2ES配电室（1）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES2T02", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES2T02", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES2T02", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES2Y02", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES2S02", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES2T02']?.now, context?.['ES2Y02']?.now, context?.['ES2S02']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
    <lay-col lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES3T02']?.cabinet_no}】${context['ES3T02']?.cabinet_name}`, location: context['ES3T02']?.location, type: context['ES3T02']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>3ES配电室（1）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES3T02", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES3T02", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES3T02", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES3Y02", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES3S02", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES3T02']?.now, context?.['ES3Y02']?.now, context?.['ES3S02']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
    <lay-col lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES4T02']?.cabinet_no}】${context['ES4T02']?.cabinet_name}`, location: context['ES4T02']?.location, type: context['ES4T02']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>4ES配电室（1）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES4T02", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES4T02", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES4T02", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES4Y02", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES4S02", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES4T02']?.now, context?.['ES4Y02']?.now, context?.['ES4S02']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
  </lay-row>
  <lay-row space="10" style="padding: 10px;color: #303030">
    <lay-col md-offset="4"  lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES1T01']?.cabinet_no}】${context['ES1T01']?.cabinet_name}`, location: context['ES1T01']?.location, type: context['ES1T01']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>1ES配电室（2）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES1T01", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES1T01", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES1T01", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES1Y01", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES1S01", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES1T01']?.now, context?.['ES1Y01']?.now, context?.['ES1S01']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
    <lay-col lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES2T01']?.cabinet_no}】${context['ES2T01']?.cabinet_name}`, location: context['ES2T01']?.location, type: context['ES2T01']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>2ES配电室（2）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES2T01", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES2T01", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES2T01", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES2Y01", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES2S01", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES2T01']?.now, context?.['ES2Y01']?.now, context?.['ES2S01']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
    <lay-col lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES3T01']?.cabinet_no}】${context['ES3T01']?.cabinet_name}`, location: context['ES3T01']?.location, type: context['ES3T01']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>3ES配电室（2）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES3T01", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES3T01", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES3T01", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES3Y01", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES3S01", 3)}}</span></p>
          </div>
        </template>
        <template #footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES3T01']?.now, context?.['ES3Y01']?.now, context?.['ES3S01']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
    <lay-col lg="4" md="4" sm="12">
      <lay-card>
        <template v-slot:title>
          <lay-button type="default" size="xs"  fluid @click="viewNodeChart({name: `【${context['ES4T01']?.cabinet_no}】${context['ES4T01']?.cabinet_name}`, location: context['ES4T01']?.location, type: context['ES4T01']?.type})"><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>4ES配电室（2）</lay-button>
        </template>
        <template v-slot:body>
          <div style="line-height: 30px;font-size: 15px">
            <p><span>温度：</span><span>{{sensorCompute("ES4T01", 0)}}</span></p>
            <p><span>湿度：</span><span :style='{color: parseFloat(sensorCompute("ES4T01", 1).value) > SD_U_LIMIT ? "red" : ""}'>{{sensorCompute("ES4T01", 1)}}</span></p>
            <p><span>烟雾：</span><span>{{sensorCompute("ES4Y01", 2)}}</span></p>
            <p><span>水浸：</span><span>{{sensorCompute("ES4S01", 3)}}</span></p>
          </div>
        </template>
        <template v-slot:footer>
          <p>
            <lay-icon type="layui-icon-time" />&nbsp;{{computed(() => maxTime([context?.['ES4T01']?.now, context?.['ES4Y01']?.now, context?.['ES4S01']?.now]))}}
          </p>
        </template>
      </lay-card>
    </lay-col>
  </lay-row>

</template>

<script setup>
import {computed, ref} from "vue";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import {useSensorCompute} from "@/assets/js/sensorCompute";
import {useRouter} from "vue-router/dist/vue-router";
import _ from "lodash";
let router = useRouter()
let context = ref({})
const SD_U_LIMIT = 80 //湿度上限
function service(data){
  for (let key in data){
    context.value[key] = data[key];
  }
}
useRealTimeDataService(service, null, {checkFR: true, dataType: 0, nodeTypes: 1, interval: 5000});
let sensorCompute = useSensorCompute(context);

function viewNodeChart(node){
  router.push({path: '/7-1', query: node})
}

function maxTime(times){
  if (!times.length || !_.every(times, Boolean)) return;
  let maxIndex = 0;
  let max = new Date(times[0].replace(' ', 'T'));
  for (let i = 1 ; i < times.length ; i++){
    let t = new Date(times[i].replace(' ', 'T'));
    if (max.getTime() < t.getTime()){
      max = t;
      maxIndex = i;
    }
  }
  return times[maxIndex];
}


</script>

<style scoped>
.chart{
  height: 650px;
  padding-top: 20px;
}
.download{
  font-size: 23px;cursor: pointer;
}
.refresh{
  font-size: 18px;cursor: pointer;
}
</style>